import React from 'react'
import { useTransition, animated } from 'react-spring'
import TheSidebar from './dashboard/sidebar/TheSidebar'

function IndexLayout({ children }) {
  const transitions = useTransition(children, {
    key: children.key,
    from: { opacity: 0, transform: '', zIndex: 1 },
    enter: { opacity: 1, transform: '', zIndex: 2 },
    leave: { opacity: 0, transform: '', zIndex: 1 },
    config: {
      duration: 300,
      tension: 170,
      friction: 26,
    },
    exitBeforeEnter: true,
  })

  return (
    <div className="flex justify-between overflow-x-hidden">
      <TheSidebar />
      <main className="ml-[25vw] h-screen w-3/4 px-[4vw] pt-[6vh]">
        {transitions((style, item) => (
          <animated.div style={style}>{item}</animated.div>
        ))}
      </main>
    </div>
  )
}

export default IndexLayout
